
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"58","viewBox":"0 0 64 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.567 19.36a3.88 3.88 0 01-3.11 1.47 4.41 4.41 0 011.11-3.23 4.7 4.7 0 013.09-1.6 4.68 4.68 0 01-1.09 3.36zm1.08 1.7c-1.72-.1-3.19 1-4 1s-2.08-.93-3.44-.9a5.1 5.1 0 00-4.32 2.62c-1.86 3.17-.49 7.89 1.31 10.5.87 1.28 1.93 2.7 3.31 2.65 1.38-.05 1.83-.86 3.42-.86 1.59 0 2 .86 3.44.83 1.44-.03 2.34-1.29 3.21-2.57a11.278 11.278 0 001.44-3 4.66 4.66 0 01-2.76-4.2 4.78 4.78 0 012.26-4 4.92 4.92 0 00-3.83-2.08l-.04.01zm9.98-3.59v19.29h3v-6.59h4.14a6.14 6.14 0 006.45-5.79c.01-.19.01-.38 0-.57a6.06 6.06 0 00-5.75-6.34h-7.84zm3 2.52h3.45c2.6 0 4.08 1.39 4.08 3.83 0 2.44-1.53 3.85-4.15 3.85h-3.44l.06-7.68zm16.01 16.92a5 5 0 004.42-2.46h.06v2.31h2.77v-9.6c0-2.78-2.22-4.57-5.65-4.57-3.18 0-5.53 1.82-5.62 4.31h2.7a2.61 2.61 0 012.83-2c1.84 0 2.86.85 2.86 2.42v1.07l-3.75.28c-3.48.21-5.36 1.63-5.36 4.11 0 2.48 1.96 4.13 4.74 4.13zm.8-2.29c-1.6 0-2.61-.76-2.61-1.94s1-1.92 2.85-2l3.33-.21v1.09c0 1.78-1.54 3.11-3.57 3.11v-.05zm10.15 7.39c2.92 0 4.29-1.11 5.49-4.49l5.26-14.75h-3.08l-3.49 11.4h-.06l-3.53-11.4h-3.13l5.07 14-.27.86a2.38 2.38 0 01-2.52 2h-.88v2.31c.378.052.759.078 1.14.08v-.01z"}})])
          )
        }
      }
    